/**
 * @desc 密码修改
 */
import styles from './index.scss';
import React, { PureComponent } from 'react';
import { Form, Input } from 'antd';
import { hashHistory } from 'react-router';
import LabelList from '../../common/labelList/LabelList';
import { PwdCheck } from '../../../utils/validator';
import messager from '../../../utils/messager';
import { clear } from '../../../utils/storage';
import { updatePwd } from '../../../services/user';
const LabelItem = LabelList.Item;
const FormItem = Form.Item;

class Pwd extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { validateFields } = this.props.form;

        validateFields({ force: true }, (err, values) => {
            if (!err) {
                this.modifyPwd(values);
            }
        });
    };

    modifyPwd = (params) => {
        if (this.saving) {
            return;
        }
        this.saving = true;

        updatePwd(params).then(() => {
            messager.success('修改成功, 请重新登录');
            clear(); // 清缓存
            hashHistory.replace('/login');
        }).finally(() => {
            this.saving = false;
        });
    };

    checkRepeat = (rule, value, callback) => {
        const { getFieldValue } = this.props.form;
        if (value && value === getFieldValue('oldPassword')) {
            callback('新密码不能与旧密码相同');
        } else {
            callback();
        }
    };

    checkPassword = (rule, value, callback) => {
        const { getFieldValue } = this.props.form;
        if (value && value !== getFieldValue('newPassword')) {
            callback('两次密码必须一致');
        } else {
            callback();
        }
    };

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div className={styles.pwd}>

                <Form className={styles.pwdForm} hideRequiredMark onSubmit={this.onSubmit}>
                    <LabelList>
                        <LabelItem label="请输入原始密码">
                            <FormItem>
                                {getFieldDecorator('oldPassword', {
                                    rules: [{
                                        required: true, message: '请输入原始密码'
                                    }, PwdCheck]
                                })(
                                    <Input type="password" placeholder="原始密码" autoComplete="off"/>
                                )}
                            </FormItem>
                        </LabelItem>
                        <LabelItem label="请输入新密码">
                            <FormItem>
                                {getFieldDecorator('newPassword', {
                                    rules: [{
                                        required: true, message: '请确认新密码'
                                    }, PwdCheck, {
                                        validator: this.checkRepeat
                                    }]
                                })(
                                    <Input type="password" placeholder="确认新密码" autoComplete="off"/>
                                )}
                            </FormItem>
                        </LabelItem>
                        <LabelItem label="请输入新密码">
                            <FormItem>
                                {getFieldDecorator('confirmPassword', {
                                    rules: [{
                                        required: true, message: '请确认新密码'
                                    }, {
                                        validator: this.checkPassword
                                    }]
                                })(
                                    <Input type="password" placeholder="确认新密码" autoComplete="off"/>
                                )}
                            </FormItem>
                        </LabelItem>
                        <LabelItem>
                            <button type="submit" className="btn btn-blue">确认修改</button>
                        </LabelItem>
                    </LabelList>
                </Form>
            </div>
        );
    }
}

export default (Form.create({})(Pwd));



// WEBPACK FOOTER //
// ./src/components/personal/pwd/Index.jsx